import React from 'react';

import { FieldRenderProps } from 'forms/types';

import MaskedTextField from '../MaskedTextField';
import { formattedNumberMask, numberMask } from '../MaskedTextField/masks';
import { NumberFieldProps } from './types';

type Props = NumberFieldProps & FieldRenderProps<number | string, HTMLInputElement, string>;

export const NumberField: React.FC<Props> = ({ formatted, maxLength = 12, ...props }) => (
  <MaskedTextField
    {...props}
    inputMode="numeric"
    maskOptions={formatted ? formattedNumberMask : numberMask}
    maxLength={maxLength}
  />
);

export default NumberField;
